import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-starter-left-side',
  templateUrl: './starter-left-side.component.html',
  styleUrls: ['./starter-left-side.component.css']
})
export class StarterLeftSideComponent implements OnInit {

  constructor(
    public router: Router
  ) { }

  ngOnInit() {
    console.log(this.router.url);
  }

}



// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/app/starter/starter-left-side/starter-left-side.component.ts